<template>
  <div id="HomePage">
    <!-- 企业资质和质量标准展示 -->
    <div id="whyChooseUs" class="container-fuild">
      <div class="container">
        <!-- 企业资质 -->
        <div class="whyChooseUs-title text-left">
          <p
            class="customer-title text-left"
            style="border-left: 10px solid #e6004c; padding-left: 15px;"
          >
            企业资质
          </p>
        </div>
        <div class="row">
          <!-- 资质1 -->
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="default-blog-news">
              <div class="img-box">
                <a
                  href="newsDetail.html?id=c8434c8e-7199-419e-70b3-08dc38f50be1"
                  target="_blank"
                >
                  <!-- 高新技术企业证书：HTML 1:1 复刻（原图 gaoxin.png 保留未删） -->
                  <div
                    class="cert-replica"
                    role="img"
                    aria-label="高新技术企业证书"
                  >
                    <div class="cert-frame">
                      <div class="cert-paper">
                        <!-- 内嵌 SVG 排版：文字随 viewBox 等比缩放，任意容器宽度都不溢出 -->
                        <svg
                          class="cert-art"
                          viewBox="0 0 400 500"
                          preserveAspectRatio="xMidYMid meet"
                          aria-hidden="true"
                        >
                          <!-- 顶部卷草花饰分隔线 -->
                          <g transform="translate(64 64) scale(0.85)">
                            <line
                              x1="10"
                              y1="12"
                              x2="116"
                              y2="12"
                              stroke="#1a1a1a"
                              stroke-width="2"
                            />
                            <line
                              x1="204"
                              y1="12"
                              x2="310"
                              y2="12"
                              stroke="#1a1a1a"
                              stroke-width="2"
                            />
                            <rect
                              x="2"
                              y="8"
                              width="8"
                              height="8"
                              transform="rotate(45 6 12)"
                              fill="#1a1a1a"
                            />
                            <rect
                              x="310"
                              y="8"
                              width="8"
                              height="8"
                              transform="rotate(45 314 12)"
                              fill="#1a1a1a"
                            />
                            <path
                              d="M122 12 C130 3 142 4 148 11"
                              fill="none"
                              stroke="#1a1a1a"
                              stroke-width="1.8"
                            />
                            <path
                              d="M198 12 C190 3 178 4 172 11"
                              fill="none"
                              stroke="#1a1a1a"
                              stroke-width="1.8"
                            />
                            <path
                              d="M148 11 C152 6.5 157 6.5 160 11 M160 11 C163 6.5 168 6.5 172 11"
                              fill="none"
                              stroke="#1a1a1a"
                              stroke-width="1.5"
                            />
                            <rect
                              x="155.5"
                              y="7.5"
                              width="9"
                              height="9"
                              transform="rotate(45 160 12)"
                              fill="#1a1a1a"
                            />
                          </g>
                          <!-- 证书标题 -->
                          <text
                            class="cert-art-title"
                            x="200"
                            y="150"
                            text-anchor="middle"
                            font-size="38"
                            letter-spacing="2.5"
                            fill="#bf1522"
                          >
                            高新技术企业证书
                          </text>
                          <text class="cert-art-recipient" x="200" y="228" text-anchor="middle" font-size="26" letter-spacing="2" fill="#161616">海南华德科技有限公司</text>
                          <!-- 落款三行 -->
                          <text
                            class="cert-art-issuer"
                            x="200"
                            y="352"
                            text-anchor="middle"
                            font-size="23"
                            letter-spacing="1.9"
                            fill="#161616"
                          >
                            海南省科学技术厅
                          </text>
                          <text
                            class="cert-art-issuer"
                            x="200"
                            y="398"
                            text-anchor="middle"
                            font-size="23"
                            letter-spacing="1.9"
                            fill="#161616"
                          >
                            海南省财政厅
                          </text>
                          <text
                            class="cert-art-issuer"
                            x="200"
                            y="444"
                            text-anchor="middle"
                            font-size="23"
                            letter-spacing="1.9"
                            fill="#161616"
                          >
                            国家税务总局海南省税务局
                          </text>
                        </svg>
                      </div>
                    </div>
                    <span class="cert-schema-tag">示意图</span>
                  </div>
                </a>
              </div>
              <div class="lower-content" style="padding-top: 10px;">
                <h4 class="post-meta text-center">高新技术企业证书</h4>
              </div>
            </div>
          </div>
          <!-- 资质2 -->
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="default-blog-news">
              <div class="img-box">
                <a
                  href="newsDetail.html?id=c8434c8e-7199-419e-70b3-08dc38f50be1"
                  target="_blank"
                >
                  <!-- 国家科技型中小企业：HTML 复刻（原图 xinyong.png 保留未删） -->
                  <div
                    class="cert-replica"
                    role="img"
                    aria-label="国家科技型中小企业"
                  >
                    <div class="cert-frame">
                      <div class="cert-paper">
                        <!-- 内嵌 SVG 排版：文字随 viewBox 等比缩放，任意容器宽度都不溢出 -->
                        <svg
                          class="cert-art"
                          viewBox="0 0 400 500"
                          preserveAspectRatio="xMidYMid meet"
                          aria-hidden="true"
                        >
                          <g transform="translate(64 64) scale(0.85)">
                            <line x1="10" y1="12" x2="116" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <line x1="204" y1="12" x2="310" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <rect x="2" y="8" width="8" height="8" transform="rotate(45 6 12)" fill="#1a1a1a"/>
                            <rect x="310" y="8" width="8" height="8" transform="rotate(45 314 12)" fill="#1a1a1a"/>
                            <path d="M122 12 C130 3 142 4 148 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M198 12 C190 3 178 4 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M148 11 C152 6.5 157 6.5 160 11 M160 11 C163 6.5 168 6.5 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.5"/>
                            <rect x="155.5" y="7.5" width="9" height="9" transform="rotate(45 160 12)" fill="#1a1a1a"/>
                          </g>
                          <text class="cert-art-title" x="200" y="150" text-anchor="middle" font-size="38" letter-spacing="2.5" fill="#bf1522">国家科技型中小企业</text>
                          <text class="cert-art-recipient" x="200" y="228" text-anchor="middle" font-size="26" letter-spacing="2" fill="#161616">海南华德科技有限公司</text>
                          <g transform="translate(112 340) scale(0.55)">
                            <line x1="10" y1="12" x2="116" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <line x1="204" y1="12" x2="310" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <rect x="2" y="8" width="8" height="8" transform="rotate(45 6 12)" fill="#1a1a1a"/>
                            <rect x="310" y="8" width="8" height="8" transform="rotate(45 314 12)" fill="#1a1a1a"/>
                            <path d="M122 12 C130 3 142 4 148 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M198 12 C190 3 178 4 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M148 11 C152 6.5 157 6.5 160 11 M160 11 C163 6.5 168 6.5 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.5"/>
                            <rect x="155.5" y="7.5" width="9" height="9" transform="rotate(45 160 12)" fill="#1a1a1a"/>
                          </g>
                          <text class="cert-art-issuer" x="200" y="430" text-anchor="middle" font-size="23" letter-spacing="1.9" fill="#161616">中华人民共和国工业和信息化部</text>
                        </svg>
                      </div>
                    </div>
                    <span class="cert-schema-tag">示意图</span>
                  </div>
                </a>
              </div>
              <div class="lower-content" style="padding-top: 10px;">
                <h4 class="post-meta text-center">国家科技型中小企业</h4>
              </div>
            </div>
          </div>
          <!-- 资质4 -->
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="default-blog-news">
              <div class="img-box">
                <a
                  href="newsDetail.html?id=c8434c8e-7199-419e-70b3-08dc38f50be1"
                  target="_blank"
                >
                  <!-- 海南省科技型中小企业：HTML 复刻（原图 ruanqi.png 保留未删） -->
                  <div
                    class="cert-replica"
                    role="img"
                    aria-label="海南省科技型中小企业"
                  >
                    <div class="cert-frame">
                      <div class="cert-paper">
                        <!-- 内嵌 SVG 排版：文字随 viewBox 等比缩放，任意容器宽度都不溢出 -->
                        <svg
                          class="cert-art"
                          viewBox="0 0 400 500"
                          preserveAspectRatio="xMidYMid meet"
                          aria-hidden="true"
                        >
                          <g transform="translate(64 64) scale(0.85)">
                            <line x1="10" y1="12" x2="116" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <line x1="204" y1="12" x2="310" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <rect x="2" y="8" width="8" height="8" transform="rotate(45 6 12)" fill="#1a1a1a"/>
                            <rect x="310" y="8" width="8" height="8" transform="rotate(45 314 12)" fill="#1a1a1a"/>
                            <path d="M122 12 C130 3 142 4 148 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M198 12 C190 3 178 4 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M148 11 C152 6.5 157 6.5 160 11 M160 11 C163 6.5 168 6.5 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.5"/>
                            <rect x="155.5" y="7.5" width="9" height="9" transform="rotate(45 160 12)" fill="#1a1a1a"/>
                          </g>
                          <text class="cert-art-title" x="200" y="150" text-anchor="middle" font-size="32" letter-spacing="2.5" fill="#bf1522">海南省科技型中小企业</text>
                          <text class="cert-art-recipient" x="200" y="228" text-anchor="middle" font-size="26" letter-spacing="2" fill="#161616">海南华德科技有限公司</text>
                          <g transform="translate(112 340) scale(0.55)">
                            <line x1="10" y1="12" x2="116" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <line x1="204" y1="12" x2="310" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <rect x="2" y="8" width="8" height="8" transform="rotate(45 6 12)" fill="#1a1a1a"/>
                            <rect x="310" y="8" width="8" height="8" transform="rotate(45 314 12)" fill="#1a1a1a"/>
                            <path d="M122 12 C130 3 142 4 148 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M198 12 C190 3 178 4 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M148 11 C152 6.5 157 6.5 160 11 M160 11 C163 6.5 168 6.5 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.5"/>
                            <rect x="155.5" y="7.5" width="9" height="9" transform="rotate(45 160 12)" fill="#1a1a1a"/>
                          </g>
                          <text class="cert-art-issuer" x="200" y="430" text-anchor="middle" font-size="23" letter-spacing="1.9" fill="#161616">海南省工业和信息化厅</text>
                        </svg>
                      </div>
                    </div>
                    <span class="cert-schema-tag">示意图</span>
                  </div>
                </a>
              </div>
              <div class="lower-content" style="padding-top: 10px;">
                <h4 class="post-meta text-center">海南省科技型中小企业</h4>
              </div>
            </div>
          </div>
          <!-- 资质3 -->
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="default-blog-news">
              <div class="img-box">
                <a
                  href="newsDetail.html?id=c8434c8e-7199-419e-70b3-08dc38f50be1"
                  target="_blank"
                >
                  <!-- 创新型中小企业：HTML 复刻（原图 chuangxin.png 保留未删） -->
                  <div
                    class="cert-replica"
                    role="img"
                    aria-label="创新型中小企业"
                  >
                    <div class="cert-frame">
                      <div class="cert-paper">
                        <!-- 内嵌 SVG 排版：文字随 viewBox 等比缩放，任意容器宽度都不溢出 -->
                        <svg
                          class="cert-art"
                          viewBox="0 0 400 500"
                          preserveAspectRatio="xMidYMid meet"
                          aria-hidden="true"
                        >
                          <g transform="translate(64 64) scale(0.85)">
                            <line x1="10" y1="12" x2="116" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <line x1="204" y1="12" x2="310" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <rect x="2" y="8" width="8" height="8" transform="rotate(45 6 12)" fill="#1a1a1a"/>
                            <rect x="310" y="8" width="8" height="8" transform="rotate(45 314 12)" fill="#1a1a1a"/>
                            <path d="M122 12 C130 3 142 4 148 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M198 12 C190 3 178 4 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M148 11 C152 6.5 157 6.5 160 11 M160 11 C163 6.5 168 6.5 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.5"/>
                            <rect x="155.5" y="7.5" width="9" height="9" transform="rotate(45 160 12)" fill="#1a1a1a"/>
                          </g>
                          <text class="cert-art-title" x="200" y="150" text-anchor="middle" font-size="40" letter-spacing="2.5" fill="#bf1522">创新型中小企业</text>
                          <text class="cert-art-recipient" x="200" y="228" text-anchor="middle" font-size="26" letter-spacing="2" fill="#161616">海南华德科技有限公司</text>
                          <g transform="translate(112 340) scale(0.55)">
                            <line x1="10" y1="12" x2="116" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <line x1="204" y1="12" x2="310" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <rect x="2" y="8" width="8" height="8" transform="rotate(45 6 12)" fill="#1a1a1a"/>
                            <rect x="310" y="8" width="8" height="8" transform="rotate(45 314 12)" fill="#1a1a1a"/>
                            <path d="M122 12 C130 3 142 4 148 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M198 12 C190 3 178 4 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M148 11 C152 6.5 157 6.5 160 11 M160 11 C163 6.5 168 6.5 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.5"/>
                            <rect x="155.5" y="7.5" width="9" height="9" transform="rotate(45 160 12)" fill="#1a1a1a"/>
                          </g>
                          <text class="cert-art-issuer" x="200" y="430" text-anchor="middle" font-size="23" letter-spacing="1.9" fill="#161616">海南省工业和信息化厅</text>
                        </svg>
                      </div>
                    </div>
                    <span class="cert-schema-tag">示意图</span>
                  </div>
                </a>
              </div>
              <div class="lower-content" style="padding-top: 10px;">
                <h4 class="post-meta text-center">创新型中小企业</h4>
              </div>
            </div>
          </div>
          <!-- 资质6 -->
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="default-blog-news">
              <div class="img-box">
                <a
                  href="newsDetail.html?id=c8434c8e-7199-419e-70b3-08dc38f50be1"
                  target="_blank"
                >
                  <!-- 海南省高新技术种子企业：HTML 复刻（原图 zhongzi.png 保留未删） -->
                  <div
                    class="cert-replica"
                    role="img"
                    aria-label="海南省高新技术种子企业"
                  >
                    <div class="cert-frame">
                      <div class="cert-paper">
                        <!-- 内嵌 SVG 排版：文字随 viewBox 等比缩放，任意容器宽度都不溢出 -->
                        <svg
                          class="cert-art"
                          viewBox="0 0 400 500"
                          preserveAspectRatio="xMidYMid meet"
                          aria-hidden="true"
                        >
                          <g transform="translate(64 64) scale(0.85)">
                            <line x1="10" y1="12" x2="116" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <line x1="204" y1="12" x2="310" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <rect x="2" y="8" width="8" height="8" transform="rotate(45 6 12)" fill="#1a1a1a"/>
                            <rect x="310" y="8" width="8" height="8" transform="rotate(45 314 12)" fill="#1a1a1a"/>
                            <path d="M122 12 C130 3 142 4 148 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M198 12 C190 3 178 4 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M148 11 C152 6.5 157 6.5 160 11 M160 11 C163 6.5 168 6.5 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.5"/>
                            <rect x="155.5" y="7.5" width="9" height="9" transform="rotate(45 160 12)" fill="#1a1a1a"/>
                          </g>
                          <text class="cert-art-title" x="200" y="128" text-anchor="middle" font-size="40" letter-spacing="2.5" fill="#bf1522">海南省高新技术</text>
                          <text class="cert-art-title" x="200" y="184" text-anchor="middle" font-size="40" letter-spacing="2.5" fill="#bf1522">种子企业</text>
                          <text class="cert-art-recipient" x="200" y="250" text-anchor="middle" font-size="26" letter-spacing="2" fill="#161616">海南华德科技有限公司</text>
                          <g transform="translate(112 345) scale(0.55)">
                            <line x1="10" y1="12" x2="116" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <line x1="204" y1="12" x2="310" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <rect x="2" y="8" width="8" height="8" transform="rotate(45 6 12)" fill="#1a1a1a"/>
                            <rect x="310" y="8" width="8" height="8" transform="rotate(45 314 12)" fill="#1a1a1a"/>
                            <path d="M122 12 C130 3 142 4 148 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M198 12 C190 3 178 4 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M148 11 C152 6.5 157 6.5 160 11 M160 11 C163 6.5 168 6.5 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.5"/>
                            <rect x="155.5" y="7.5" width="9" height="9" transform="rotate(45 160 12)" fill="#1a1a1a"/>
                          </g>
                          <text class="cert-art-issuer" x="200" y="430" text-anchor="middle" font-size="23" letter-spacing="1.9" fill="#161616">海南省科学技术厅</text>
                        </svg>
                      </div>
                    </div>
                    <span class="cert-schema-tag">示意图</span>
                  </div>
                </a>
              </div>
              <div class="lower-content" style="padding-top: 10px;">
                <h4 class="post-meta text-center">海南省高新技术种子企业</h4>
              </div>
            </div>
          </div>
        
          <!-- 资质5 -->
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="default-blog-news">
              <div class="img-box">
                <a
                  href="newsDetail.html?id=c8434c8e-7199-419e-70b3-08dc38f50be1"
                  target="_blank"
                >
                  <!-- 海南省大数据产业联盟会员单位：HTML 复刻（原图 dashuju.png 保留未删） -->
                  <div
                    class="cert-replica"
                    role="img"
                    aria-label="海南省大数据产业联盟会员单位"
                  >
                    <div class="cert-frame">
                      <div class="cert-paper">
                        <!-- 内嵌 SVG 排版：文字随 viewBox 等比缩放，任意容器宽度都不溢出 -->
                        <svg
                          class="cert-art"
                          viewBox="0 0 400 500"
                          preserveAspectRatio="xMidYMid meet"
                          aria-hidden="true"
                        >
                          <g transform="translate(64 64) scale(0.85)">
                            <line x1="10" y1="12" x2="116" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <line x1="204" y1="12" x2="310" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <rect x="2" y="8" width="8" height="8" transform="rotate(45 6 12)" fill="#1a1a1a"/>
                            <rect x="310" y="8" width="8" height="8" transform="rotate(45 314 12)" fill="#1a1a1a"/>
                            <path d="M122 12 C130 3 142 4 148 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M198 12 C190 3 178 4 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M148 11 C152 6.5 157 6.5 160 11 M160 11 C163 6.5 168 6.5 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.5"/>
                            <rect x="155.5" y="7.5" width="9" height="9" transform="rotate(45 160 12)" fill="#1a1a1a"/>
                          </g>
                          <text class="cert-art-title" x="200" y="128" text-anchor="middle" font-size="32" letter-spacing="2.5" fill="#bf1522">海南省大数据产业联盟</text>
                          <text class="cert-art-title" x="200" y="184" text-anchor="middle" font-size="40" letter-spacing="2.5" fill="#bf1522">会员单位</text>
                          <text class="cert-art-recipient" x="200" y="250" text-anchor="middle" font-size="26" letter-spacing="2" fill="#161616">海南华德科技有限公司</text>
                          <g transform="translate(112 345) scale(0.55)">
                            <line x1="10" y1="12" x2="116" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <line x1="204" y1="12" x2="310" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <rect x="2" y="8" width="8" height="8" transform="rotate(45 6 12)" fill="#1a1a1a"/>
                            <rect x="310" y="8" width="8" height="8" transform="rotate(45 314 12)" fill="#1a1a1a"/>
                            <path d="M122 12 C130 3 142 4 148 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M198 12 C190 3 178 4 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M148 11 C152 6.5 157 6.5 160 11 M160 11 C163 6.5 168 6.5 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.5"/>
                            <rect x="155.5" y="7.5" width="9" height="9" transform="rotate(45 160 12)" fill="#1a1a1a"/>
                          </g>
                          <text class="cert-art-issuer" x="200" y="430" text-anchor="middle" font-size="23" letter-spacing="1.9" fill="#161616">海南省大数据产业联盟</text>
                        </svg>
                      </div>
                    </div>
                    <span class="cert-schema-tag">示意图</span>
                  </div>
                </a>
              </div>
              <div class="lower-content" style="padding-top: 10px;">
                <h4 class="post-meta text-center">
                  海南省大数据产业联盟会员单位
                </h4>
              </div>
            </div>
          </div>
        </div>

        <!-- 质量标准 -->
        <div class="whyChooseUs-title text-left" style="margin-top: 40px;">
          <p
            class="customer-title text-left"
            style="border-left: 10px solid #e6004c; padding-left: 15px;"
          >
            质量标准
          </p>
        </div>
        <div class="row">
          <!-- 标准1 -->
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="default-blog-news">
              <div class="img-box">
                <a
                  href="newsDetail.html?id=c8434c8e-7199-419e-70b3-08dc38f50be1"
                  target="_blank"
                >
                  <!-- 质量管理体系认证（ISO9001:2015）：HTML 复刻（原图 9001.png 保留未删） -->
                  <div
                    class="cert-replica cert-replica-iso"
                    role="img"
                    aria-label="质量管理体系认证（ISO9001:2015）"
                  >
                    <div class="cert-frame">
                      <div class="cert-paper">
                        <!-- 内嵌 SVG 排版：文字随 viewBox 等比缩放，任意容器宽度都不溢出 -->
                        <svg
                          class="cert-art"
                          viewBox="0 0 480 340"
                          preserveAspectRatio="xMidYMid meet"
                          aria-hidden="true"
                        >
                          <g transform="translate(104 52) scale(0.85)">
                            <line x1="10" y1="12" x2="116" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <line x1="204" y1="12" x2="310" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <rect x="2" y="8" width="8" height="8" transform="rotate(45 6 12)" fill="#1a1a1a"/>
                            <rect x="310" y="8" width="8" height="8" transform="rotate(45 314 12)" fill="#1a1a1a"/>
                            <path d="M122 12 C130 3 142 4 148 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M198 12 C190 3 178 4 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M148 11 C152 6.5 157 6.5 160 11 M160 11 C163 6.5 168 6.5 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.5"/>
                            <rect x="155.5" y="7.5" width="9" height="9" transform="rotate(45 160 12)" fill="#1a1a1a"/>
                          </g>
                          <text class="cert-art-title" x="240" y="112" text-anchor="middle" font-size="36" letter-spacing="2.5" fill="#bf1522">质量管理体系认证</text>
                          <text class="cert-art-title" x="240" y="164" text-anchor="middle" font-size="34" letter-spacing="2.5" fill="#bf1522">（ISO9001:2015）</text>
                          <text class="cert-art-recipient" x="240" y="222" text-anchor="middle" font-size="24" letter-spacing="2" fill="#161616">海南华德科技有限公司</text>
                          <g transform="translate(152 276) scale(0.55)">
                            <line x1="10" y1="12" x2="116" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <line x1="204" y1="12" x2="310" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <rect x="2" y="8" width="8" height="8" transform="rotate(45 6 12)" fill="#1a1a1a"/>
                            <rect x="310" y="8" width="8" height="8" transform="rotate(45 314 12)" fill="#1a1a1a"/>
                            <path d="M122 12 C130 3 142 4 148 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M198 12 C190 3 178 4 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M148 11 C152 6.5 157 6.5 160 11 M160 11 C163 6.5 168 6.5 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.5"/>
                            <rect x="155.5" y="7.5" width="9" height="9" transform="rotate(45 160 12)" fill="#1a1a1a"/>
                          </g>
                        </svg>
                      </div>
                    </div>
                    <span class="cert-schema-tag">示意图</span>
                  </div>
                </a>
              </div>
              <div class="lower-content" style="padding-top: 10px;">
                <h4 class="post-meta text-center">质量管理体系认证</h4>
              </div>
            </div>
          </div>
          <!-- 标准2 -->
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="default-blog-news">
              <div class="img-box">
                <a
                  href="newsDetail.html?id=c8434c8e-7199-419e-70b3-08dc38f50be1"
                  target="_blank"
                >
                  <!-- 环境管理体系认证（ISO14001:2015）：HTML 复刻（原图 14001.png 保留未删） -->
                  <div
                    class="cert-replica cert-replica-iso"
                    role="img"
                    aria-label="环境管理体系认证（ISO14001:2015）"
                  >
                    <div class="cert-frame">
                      <div class="cert-paper">
                        <!-- 内嵌 SVG 排版：文字随 viewBox 等比缩放，任意容器宽度都不溢出 -->
                        <svg
                          class="cert-art"
                          viewBox="0 0 480 340"
                          preserveAspectRatio="xMidYMid meet"
                          aria-hidden="true"
                        >
                          <g transform="translate(104 52) scale(0.85)">
                            <line x1="10" y1="12" x2="116" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <line x1="204" y1="12" x2="310" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <rect x="2" y="8" width="8" height="8" transform="rotate(45 6 12)" fill="#1a1a1a"/>
                            <rect x="310" y="8" width="8" height="8" transform="rotate(45 314 12)" fill="#1a1a1a"/>
                            <path d="M122 12 C130 3 142 4 148 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M198 12 C190 3 178 4 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M148 11 C152 6.5 157 6.5 160 11 M160 11 C163 6.5 168 6.5 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.5"/>
                            <rect x="155.5" y="7.5" width="9" height="9" transform="rotate(45 160 12)" fill="#1a1a1a"/>
                          </g>
                          <text class="cert-art-title" x="240" y="112" text-anchor="middle" font-size="36" letter-spacing="2.5" fill="#bf1522">环境管理体系认证</text>
                          <text class="cert-art-title" x="240" y="164" text-anchor="middle" font-size="34" letter-spacing="2.5" fill="#bf1522">（ISO14001:2015）</text>
                          <text class="cert-art-recipient" x="240" y="222" text-anchor="middle" font-size="24" letter-spacing="2" fill="#161616">海南华德科技有限公司</text>
                          <g transform="translate(152 276) scale(0.55)">
                            <line x1="10" y1="12" x2="116" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <line x1="204" y1="12" x2="310" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <rect x="2" y="8" width="8" height="8" transform="rotate(45 6 12)" fill="#1a1a1a"/>
                            <rect x="310" y="8" width="8" height="8" transform="rotate(45 314 12)" fill="#1a1a1a"/>
                            <path d="M122 12 C130 3 142 4 148 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M198 12 C190 3 178 4 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M148 11 C152 6.5 157 6.5 160 11 M160 11 C163 6.5 168 6.5 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.5"/>
                            <rect x="155.5" y="7.5" width="9" height="9" transform="rotate(45 160 12)" fill="#1a1a1a"/>
                          </g>
                        </svg>
                      </div>
                    </div>
                    <span class="cert-schema-tag">示意图</span>
                  </div>
                </a>
              </div>
              <div class="lower-content" style="padding-top: 10px;">
                <h4 class="post-meta text-center">环境管理体系认证</h4>
              </div>
            </div>
          </div>
          <!-- 标准3 -->
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="default-blog-news">
              <div class="img-box">
                <a
                  href="newsDetail.html?id=c8434c8e-7199-419e-70b3-08dc38f50be1"
                  target="_blank"
                >
                  <!-- 职业健康安全管理体系认证（ISO45001:2018）：HTML 复刻（原图 45001.png 保留未删） -->
                  <div
                    class="cert-replica cert-replica-iso"
                    role="img"
                    aria-label="职业健康安全管理体系认证（ISO45001:2018）"
                  >
                    <div class="cert-frame">
                      <div class="cert-paper">
                        <!-- 内嵌 SVG 排版：文字随 viewBox 等比缩放，任意容器宽度都不溢出 -->
                        <svg
                          class="cert-art"
                          viewBox="0 0 480 340"
                          preserveAspectRatio="xMidYMid meet"
                          aria-hidden="true"
                        >
                          <g transform="translate(104 52) scale(0.85)">
                            <line x1="10" y1="12" x2="116" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <line x1="204" y1="12" x2="310" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <rect x="2" y="8" width="8" height="8" transform="rotate(45 6 12)" fill="#1a1a1a"/>
                            <rect x="310" y="8" width="8" height="8" transform="rotate(45 314 12)" fill="#1a1a1a"/>
                            <path d="M122 12 C130 3 142 4 148 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M198 12 C190 3 178 4 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M148 11 C152 6.5 157 6.5 160 11 M160 11 C163 6.5 168 6.5 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.5"/>
                            <rect x="155.5" y="7.5" width="9" height="9" transform="rotate(45 160 12)" fill="#1a1a1a"/>
                          </g>
                          <text class="cert-art-title" x="240" y="112" text-anchor="middle" font-size="30" letter-spacing="2.5" fill="#bf1522">职业健康安全管理体系认证</text>
                          <text class="cert-art-title" x="240" y="164" text-anchor="middle" font-size="34" letter-spacing="2.5" fill="#bf1522">（ISO45001:2018）</text>
                          <text class="cert-art-recipient" x="240" y="222" text-anchor="middle" font-size="24" letter-spacing="2" fill="#161616">海南华德科技有限公司</text>
                          <g transform="translate(152 276) scale(0.55)">
                            <line x1="10" y1="12" x2="116" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <line x1="204" y1="12" x2="310" y2="12" stroke="#1a1a1a" stroke-width="2"/>
                            <rect x="2" y="8" width="8" height="8" transform="rotate(45 6 12)" fill="#1a1a1a"/>
                            <rect x="310" y="8" width="8" height="8" transform="rotate(45 314 12)" fill="#1a1a1a"/>
                            <path d="M122 12 C130 3 142 4 148 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M198 12 C190 3 178 4 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>
                            <path d="M148 11 C152 6.5 157 6.5 160 11 M160 11 C163 6.5 168 6.5 172 11" fill="none" stroke="#1a1a1a" stroke-width="1.5"/>
                            <rect x="155.5" y="7.5" width="9" height="9" transform="rotate(45 160 12)" fill="#1a1a1a"/>
                          </g>
                        </svg>
                      </div>
                    </div>
                    <span class="cert-schema-tag">示意图</span>
                  </div>
                </a>
              </div>
              <div class="lower-content" style="padding-top: 10px;">
                <h4 class="post-meta text-center">职业健康安全管理体系认证</h4>
              </div>
            </div>
          </div>
        </div>
        <p class="cert-disclaimer">说明：本页证书均为版式示意，非扫描件，证书以原件为准。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
  methods: {} // 移除了未使用的toLink方法
};
</script>

<style scoped>
/* 引入必要的bootstrap样式 */
@import url("../assets/css/bootstrap.min.css");

/* 整体容器样式 */
#HomePage {
  width: 100%;
}

/* 资质/标准板块整体样式 */
#whyChooseUs {
  padding: 50px 0;
}

/* 标题样式 */
.whyChooseUs-title {
  margin-bottom: 50px;
  color: rgb(102, 102, 102);
}

.customer-title {
  font-size: 30px;
  color: rgb(102, 102, 102);
  margin: 0 0 30px;
}

/* 证书卡片基础样式 */
.default-blog-news .img-box {
  width: 100%;
  /* 屏幕自适应：证书按「文档尺寸」封顶 300px 并居中，不再随卡片/大屏无限放大。
     1920 视口下卡片内容宽 374 → 不加限制时证书 375×469，一张证书比半个屏幕还高（用户实锤"太大"）。
     ⚠️ 限宽必须加在这一层（父容器）：.cert-replica 靠 padding-bottom:125% 撑比例，
        而百分比 padding 是按父容器宽度算的，直接给 .cert-replica 加 max-width 会让宽高比失真
        （实测 300 宽却撑出 468 高，金框被拉高）。
     1280 及以上视口证书恒为 300px；1280 以下按卡片宽度自然缩小，手机单列时同样封顶 300。 */
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
}

/* 文字内容样式 */
.lower-content {
  padding-top: 10px;
}

.post-meta {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  text-align: center;
}

/* 证书卡片（S2：白卡留白，证书不再顶天立地） */
.default-blog-news {
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
}

.default-blog-news:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

/* ===== HTML 证书复刻（内嵌 SVG 排版：文字随 viewBox 等比缩放，任意宽度不溢出、零兼容性风险） ===== */
/* 结构：.cert-replica（藏青外框）> .cert-frame（金色边）> .cert-paper（白色纸面）> svg.cert-art */
/* 用 padding-bottom 撑 4:5 竖版比例 + 绝对定位，兼容不支持 aspect-ratio 的老内核 */
.cert-replica {
  position: relative;
  width: 100%;
  /* ⚠️ 这里不能加 max-width 来限尺寸：padding-bottom:125% 是按「父容器宽度」计算的，
     一旦元素自身被 max-width 收窄，宽高比立刻失真（实测 300 宽却撑出 468 高，金框被拉高）。
     证书尺寸统一由父容器 .img-box 封顶（见下方 .default-blog-news .img-box）。 */
  height: 0;
  padding-bottom: 125%;
  background: linear-gradient(160deg, #f8f0dc, #f2e6ca 55%, #f5ebd4);
  box-sizing: border-box;
  display: block;
  transition: transform 0.3s ease;
}

.img-box:hover .cert-replica {
  transform: scale(1.05);
}

.cert-frame {
  position: absolute;
  top: 2.1%;
  right: 2.1%;
  bottom: 2.1%;
  left: 2.1%;
  box-sizing: border-box;
  border: 0.32em solid #b8923f;
  padding: 0.26em;
  box-shadow: inset 0 0 0 1px rgba(184, 146, 63, 0.22);
}

.cert-paper {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: 0.12em solid #c9a95e;
  background: radial-gradient(120% 100% at 50% 38%, #fffef9 55%, #f8f1e0);
}

.cert-art {
  display: block;
  width: 100%;
  height: 100%;
}

/* SVG 内文字字体（字号写在 viewBox 坐标上，随整体等比缩放） */
.cert-art-title {
  font-family: "STZhongsong", "华文中宋", "SimSun", "宋体", "Microsoft YaHei",
    serif;
  font-weight: 900;
}

.cert-art-issuer {
  font-family: "SimHei", "黑体", "Microsoft YaHei", sans-serif;
  font-weight: 700;
}
.cert-replica-iso {
  padding-bottom: 71%;
}

.cert-schema-tag {
  position: absolute;
  right: 6px;
  bottom: 6px;
  font-size: 12px;
  line-height: 1;
  color: #676767;
  background: rgba(255, 255, 255, 0.78);
  padding: 2px 6px;
  border-radius: 3px;
  z-index: 2;
}

.cert-disclaimer {
  text-align: center;
  font-size: 12px;
  color: #676767;
  margin-top: 24px;
}

.cert-art-recipient {
  font-family: "SimHei", "黑体", "Microsoft YaHei", sans-serif;
  font-weight: 700;
}

/* 平板设备适配 */
@media screen and (min-width: 768px) and (max-width: 992px) {
  .cert-replica {
    font-size: 8.5px;
  }
}

/* 手机设备适配 */
@media screen and (max-width: 768px) {
  .cert-replica {
    font-size: 7px;
  }
}

/* 超小屏幕优化 (<575px)：单列布局，容器接近全屏宽 */
@media screen and (max-width: 575px) {
  .cert-replica {
    font-size: 12px;
  }
}

@media screen and (max-width: 480px) {
  .cert-replica {
    font-size: 10.5px;
  }
}

@media screen and (max-width: 350px) {
  .cert-replica {
    font-size: 9px;
  }
}

/* 手机设备适配 */
@media screen and (max-width: 768px) {
  .customer-title {
    font-size: 18px;
    padding-left: 12px !important;
    border-left-width: 6px !important;
  }

  .post-meta {
    font-size: 14px;
  }
}

/* 小手机设备适配 */
@media screen and (max-width: 480px) {
  .customer-title {
    font-size: 16px;
    padding-left: 10px !important;
  }
}

/* 超小屏幕优化 (<575px) */
@media screen and (max-width: 575px) {
  #whyChooseUs {
    padding: 20px 0;
  }

  #whyChooseUs .container {
    padding-left: 10px;
    padding-right: 10px;
  }

  .whyChooseUs-title {
    margin-bottom: 30px !important;
  }

  .row {
    margin-left: -5px;
    margin-right: -5px;
  }

  .col-xs-12 {
    padding-left: 5px;
    padding-right: 5px;
    margin-bottom: 15px;
    /* 手机竖向改 2 列网格：原单张满宽时证书 300px ≈ 屏宽 77%（用户实锤"小屏显得太大")。
       改 50% 后每张约占半宽，证书随卡片自然缩到 ~180px，形成整齐的证书墙。
       ⚠️ .col-xs-12 在本页只用于证书卡（grep 确认无其它 col-xs-12 区块），故可直接作用于它；
       若日后本页引入其它 col-xs-12 区块，需改为父容器限定写法。
       仅作用于 ≤575px（本媒体查询作用域），不影响平板/桌面 2~3 列布局。
       与 HomePage2.vue 荣誉资质区口径一致。 */
    width: 50%;
  }

  /* 卡片优化 */
  .default-blog-news {
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    height: 100%;
    transition: all 0.3s ease;
  }

  .default-blog-news:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  /* 证书容器：必须高度自适应，否则证书被纵向裁切。
     ⚠️ 这里原为 height:150px（+ flex 居中 + 灰底 + 10px 内边距），是当年放 <img>
     缩略图时的写法。现在 9 张证书全是 .cert-replica（padding-bottom:125% 撑 4:5 竖版，
     约 375~400px 高），塞进 150px 的固定高容器后被上下居中溢出裁掉，
     证书顶部的红字标题行整条看不见（用户手机实锤）。
     页面已无任何 <img>，故一并去掉灰底/内边距/居中，让证书按卡片宽度完整展示。 */
  .img-box {
    height: auto;
    overflow: hidden;
    display: block;
    background-color: transparent;
    padding: 0;
  }

  .img-box a {
    display: block;
    width: 100%;
    height: auto;
    text-decoration: none;
  }

  .lower-content {
    padding: 12px 8px 15px !important;
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
  }

  .post-meta {
    line-height: 1.4;
    margin: 0;
    padding: 0 5px;
    word-break: break-word;
  }
}

/* 极窄屏幕优化 (<350px) */
@media screen and (max-width: 350px) {
  .customer-title {
    font-size: 15px !important;
    border-left-width: 4px !important;
  }

  /* 同上：证书容器不再限高（原 height:120px 会继续裁切证书） */
  .post-meta {
    font-size: 12px !important;
    line-height: 1.3;
  }

  #whyChooseUs .container {
    padding-left: 8px;
    padding-right: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/NewsInformation.vue